// extracted by mini-css-extract-plugin
export default {"content":"TermsofUsePage_content__dB59C","oneTab":"TermsofUsePage_oneTab__USTCi","twoTab":"TermsofUsePage_twoTab__8OmvC"};